import { render } from "./PendingRequests.vue?vue&type=template&id=5b02222e"
import script from "./PendingRequests.vue?vue&type=script&lang=js"
export * from "./PendingRequests.vue?vue&type=script&lang=js"

import "./PendingRequests.vue?vue&type=style&index=0&id=5b02222e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__